module.exports = __webpack_public_path__ + "static/media/bt-logo.5324f789.png";